// config/env.ts
export const isBeta = process.env.REACT_APP_ENV === 'beta';